import React, { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  styled,
  Typography,
} from "@mui/material";
import Close from "@material-ui/icons/Close";
import Button from "components/Forms/CustomButtons/ButtonTS";

import { useTranslation } from "react-i18next";
import { MuiIconName } from "utils/renderIcons/MuiIconName";
import { IconRenderer } from "utils/renderIcons";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "1rem",
  },
}));

enum ColorButtonAction {
  "action" = "primary",
  "confirm-action" = "success",
  "sensitive-action" = "danger",
}

enum TextButtonAction {
  "action" = "back",
  "confirm-action" = "conclude",
  "sensitive-action" = "proceed",
}

interface LayoutModalInformationProps {
  children: ReactNode;
  modalOpen: boolean;
  onClose: () => void;
  onAction?: () => void;
  modalType: "confirm-action" | "sensitive-action" | "action";
  title: string;
  subtitle?: string;
  maxWidth?: false | "lg" | "xs" | "sm" | "md" | "xl";
  buttonClose?: boolean;
  iconTitle?: MuiIconName;
  iconColor?: string;
}

export const LayoutModalInformation: React.FC<LayoutModalInformationProps> = ({
  children,
  modalOpen,
  onClose,
  onAction,
  modalType,
  title,
  subtitle,
  maxWidth = "md",
  buttonClose = true,
  iconTitle,
  iconColor,
}) => {
  const { t } = useTranslation(["modals"]);

  const handleClose = (event: object, reason: string) => {
    if (reason === "backdropClick") return; // Impede o fechamento ao clicar no backdrop
    onClose();
  };

  return (
    <>
      <CustomDialog
        open={modalOpen}
        fullWidth
        maxWidth={maxWidth}
        scroll="body"
        onClose={handleClose}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            textAlign="center"
            sx={{
              opacity: "0.9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
            }}
          >
            {iconTitle && (
              <IconRenderer
                iconName={iconTitle}
                size={"2rem"}
                color={iconColor}
              />
            )}
            {t(title, { ns: "modals" })}
          </Typography>
          {subtitle && (
            <Typography
              variant="subtitle1"
              textAlign="center"
              sx={{ opacity: "0.75" }}
            >
              {subtitle}
            </Typography>
          )}
          {buttonClose && (
            <Button
              justIcon
              simple
              color="tumblr"
              round
              size="md"
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
              }}
              onClick={onClose}
            >
              <Close />
            </Button>
          )}
        </DialogTitle>
        <Divider style={{ backgroundColor: "#808080", margin: "0rem 2rem" }} />
        <DialogContent
          sx={{
            margin: "1rem",
          }}
        >
          {children}
        </DialogContent>

        {onAction && (
          <DialogActions
            sx={{
              margin: "0rem 2rem",
            }}
          >
            <Button color={ColorButtonAction[modalType]} onClick={onAction}>
              {t(TextButtonAction[modalType])}
            </Button>
          </DialogActions>
        )}
      </CustomDialog>
    </>
  );
};
